// extracted by mini-css-extract-plugin
export default {"ep_banner":"ExpiredPlanBanner_ep_banner__OEVaB","banner__inner":"ExpiredPlanBanner_banner__inner__CRZX1","banner__text":"ExpiredPlanBanner_banner__text__FH-tS"};